import React from "react";
import componentQueries from "react-component-queries";
import styled, { withTheme } from "styled-components";
import { range, partition, chain } from "lodash";
import { compose } from "redux";
import LazyLoad from "react-lazyload";
import Masonry from "../../components/masonry";
import ProjectThumbnail from "./project-thumbnail";

const Container = styled.div`
  a {
    text-decoration: none;
  }
    opacity = ${({ opacity }) => opacity};
`;

const featureEveryNth = 5;
const availableWidths = [100, 90, 80, 70];

function rotateArray(arr, times) {
  const t = times % arr.length;

  if (arr.length === 0 || arr.length === 1) {
    return arr;
  }
  if (t === 0) {
    return arr;
  }

  const [head, ...tail] = arr;
  const rotated = tail.concat(head);

  return rotateArray(rotated, t - 1);
}
const thumbnailWidthPattern = rotateArray(
  chain(range(featureEveryNth))
    .map(i => availableWidths[i % availableWidths.length])
    .map(w => `${w}%`)
    .value(),
  Math.floor(Math.random() * availableWidths.length)
);

const withComponentQueries = componentQueries(
  ({ width }, { theme: { mobile } }) => {
    const layoutProps = (function mapWidthToLayoutProps() {
      const dFault = {
        label: null,
        gridProps: {
          gutter: `${width / 25}px`
        }
      };

      if (mobile.isMobile) {
        if (width > 1000) {
          return {
            ...dFault,
            label: {
              f: 8,
              mt: 5
            }
          };
        }

        if (width > 700) {
          return {
            ...dFault,
            label: {
              f: 9,
              mt: 6
            }
          };
        }

        if (width > 500) {
          return {
            ...dFault,
            label: {
              f: 10,
              mt: 6
            }
          };
        }

        return {
          ...dFault,
          label: {
            f: 11,
            mt: 7
          }
        };
      }

      return dFault;
    })();

    return {
      layoutProps
    };
  }
);

export default compose(withTheme, withComponentQueries)(
  class extends React.Component {
    render() {
      const {
        focusedProject,
        onProjectFocus,
        onProjectBlur,
        layoutProps,
        projects
      } = this.props;
      const { gridProps } = layoutProps;
      const thumbnails = chain(projects)
        .sortBy(p => p.updatedAt)
        .reverse()
        .map((item, i) => {
          const thumbnailWidth =
            thumbnailWidthPattern[i % thumbnailWidthPattern.length];
          const featured = (i + 1) % featureEveryNth === 0;
          const project = item;
          const focused = focusedProject
            ? focusedProject.id === project.id
            : true;
          return {
            key: i,
            span: featured ? 2 : 1,
            element: (
              <ProjectThumbnail
                opacity={focused ? 1 : 0.5}
                project={project}
                w={featured ? "100%" : thumbnailWidth}
                labelProps={layoutProps.label}
                onMouseEnter={() => onProjectFocus(project)}
                onMouseLeave={() => onProjectBlur(project)}
                onLoad={null}
              />
            )
          };
        })
        .value();
      const [initialThumbnails, lazyThumbnails] = partition(
        thumbnails,
        t => t.key < featureEveryNth * 2
      );
      return (
        <Container>
          <Masonry gutter={gridProps.gutter} elements={initialThumbnails} />
          <LazyLoad offset={100} once>
            <Masonry gutter={gridProps.gutter} elements={lazyThumbnails} />
          </LazyLoad>
        </Container>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/components/feed/index.js